import type { DateTime } from "luxon";
import type { FunctionComponent } from "react";

import dateFormat from "@/utils/date";

export const DateCell: FunctionComponent = ({ children }) =>
  children ? dateFormat(children as DateTime) : <></>;
